<div class="main-container" >



    <mat-toolbar color="#FFFFFF" class="topbar telative" style="background-color: #FFFFFF; position: relative;">

        <div class="navbar-header" style="text-align: left;">

            <a class="navbar-brand">
                <b>

                    <img src="assets/images/logos/PrimeRx-Logo.jpg" style="height: 40px; width: auto;" alt="homepage" class="light-logo">

                </b>

                <span fxShow="false" fxShow.gt-xs>

                </span> </a>
        </div>

        <!-- <button mat-icon-button (click)="snav.toggle()" value="sidebarclosed" color="primary" matTooltip="Show/Hide Menu">
            <mat-icon>menu</mat-icon>
        </button> -->

        <label  class="environment-chip-container" [ngStyle]="{ 'background-color': envColor , 'color': envTextColor }">
            {{ environment }}
        </label>

        <span fxFlex></span>

        <app-header></app-header>

    </mat-toolbar>



    <!-- <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0">
        <mat-sidenav #snav class="dark-sidebar pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'"
            style="background-color: #1B2033;"  fixedTopGap="0"
            [opened]="mobileQuery.matches"  [disableClose]="mobileQuery.matches " >

            <app-sidebar>
            </app-sidebar>

        </mat-sidenav>

        <mat-sidenav-content class="page-wrapper">
            <div>
                <router-outlet></router-outlet>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container> -->
    <mat-drawer-container class="example-container mat-typography" autosize>
        <mat-drawer #drawer mode="side" disableClose="true" opened="true" style="background-color: #1B2033;"
            [ngStyle]="{'width.px': sidebarCollapsed ? 64 : 250}">

            <!-- app-sidebar-nav (inside app-sidebar) owns its own collapse
                 toggle button and footer now — see
                 ReusableComponents/sidebar-nav. -->
            <app-sidebar [collapsed]="sidebarCollapsed" (collapsedChange)="sidebarCollapsed = $event">
            </app-sidebar>

        </mat-drawer>

        <mat-drawer-content class="page-wrapper">
            <div>
                <router-outlet></router-outlet>
            </div>
        </mat-drawer-content>

    </mat-drawer-container>
</div>
